import React from 'react'
import { ThemeProvider as VThemeProvider } from '@veneer/theme'
import { extendSystem } from '@veneer/system'
import tokens from '@veneer/tokens'
import { rgba } from './../../utils/helper'

export const hpxTokens = {
  manatee0: '#FDFDFF',
  manatee1: '#F5F6FF',
  manatee2: '#EDEEFE',
  manatee3: '#E0E1EE',
  manatee4: '#D1D2E4',
  manatee5: '#B5B7CB',
  manatee6: '#9B9CB1',
  manatee7: '#828398',
  manatee8: '#696B7E',
  manatee9: '#525365',
  manatee10: '#3C3D4B',
  manatee11: '#292A35',
  manatee12: '#191A22'
}

const hpxTheme = extendSystem({
  palette: {
    light: {
      primary: {
        active: tokens.color.royalBlue9,
        background: tokens.color.royalBlue0,
        default: tokens.color.royalBlue7,
        hover: tokens.color.royalBlue8,
      },
      background: {
        active: hpxTokens.manatee2,
        background: tokens.color.white,
        default: hpxTokens.manatee3,
        hover: hpxTokens.manatee1,
      },
      foreground: {
        active: tokens.color.gray12,
        background: '',
        default: hpxTokens.manatee12,
        hover: tokens.color.gray12,
      },
      stroke: {
        active: '',
        background: '',
        default: hpxTokens.manatee2,
        hover: '',
      },
      warning: {
        active: tokens.color.gold1,
        background: '',
        default: '',
        hover: tokens.color.gold2,
      },
      negative: {
        active: '',
        background: '',
        default: '',
        hover: '',
      },
      positive: {
        active: '',
        background: '',
        default: '',
        hover: '',
      },
      neutral: {
        active: hpxTokens.manatee9,
        background: hpxTokens.manatee1,
        default: hpxTokens.manatee7,
        hover: hpxTokens.manatee8,
      },
    }
  },
})

export const getThemeProviderConfig = (uiBrand) => {
  const config = {
    customSemantics: hpxTheme,
    mode: 'light',
    shape: 'pill',
    density: 'standard',
    inputBackground: undefined
  }


  return config
}

const ThemeProvider = ({ children }) => {
  const props = getThemeProviderConfig('hpx')

  return <VThemeProvider {...props}>{children}</VThemeProvider>
}

export default ThemeProvider